import React from 'react';
import ReactModal from 'react-modal';
import EventoForm from './EventoForm';
import SubEventoForm from './SubEventoForm';



class EventoNuevo extends React.Component {
    constructor () {
      super();
      this.state = {
        showModal: false
      };
      
      this.handleOpenModal = this.handleOpenModal.bind(this);
      this.handleCloseModal = this.handleCloseModal.bind(this);
    }
    
    handleOpenModal () {
      this.setState({ showModal: true });
    }
    
    handleCloseModal () {
      this.setState({ showModal: false });
    }
    
    
    render () {
      return (
        <div>
          <button className="btn btn-success" onClick={this.handleOpenModal}>Añadir Evento</button>
          <ReactModal
             isOpen={this.state.showModal}
             contentLabel="Nuevo Evento"
             htmlOpenClassName="col-md-6"
          >
            <button className="btn btn-danger" onClick={this.handleCloseModal}>Cerrar</button>
            <EventoForm/>
          </ReactModal>
        </div>
      );
    }
  }

  export default EventoNuevo;